import React from 'react';
import { Zap, Mail, Globe } from 'lucide-react';
const platforms = ['Workana', 'Fiverr', 'Upwork', 'LinkedIn', 'Payoneer', 'Wise', 'MercadoPago'];
export function Footer() {
  return <footer className="bg-[#050505] pt-16 pb-8 border-t border-white/10 relative z-10" data-id="element-300">
      <div className="container mx-auto px-4" data-id="element-301">
        {/* Platforms Strip */}
        <div className="mb-12 border-b border-white/5 pb-10" data-id="element-302">
          <div className="flex items-center justify-center gap-4 mb-6" data-id="element-303">
            <div className="h-px bg-gradient-to-r from-transparent to-electric/50 flex-1 max-w-[100px]" data-id="element-304"></div>
            <p className="text-[10px] tracking-widest uppercase text-textsecondary text-center" data-id="element-305">
              Integrado con las plataformas donde está tu próximo cliente
            </p>
            <div className="h-px bg-gradient-to-l from-transparent to-electric/50 flex-1 max-w-[100px]" data-id="element-306"></div>
          </div>
          <div className="flex flex-wrap justify-center gap-3" data-id="element-307">
            {platforms.map(p => <div key={p} className="flex items-center gap-2 bg-petroleum border border-electric/15 rounded-lg px-3 py-1.5 text-textsecondary text-xs hover:border-electric/40 hover:text-white transition-colors cursor-default" data-id="element-308">
                <div className="w-1.5 h-1.5 rounded-full bg-energy" data-id="element-309"></div>
                {p}
              </div>)}
          </div>
        </div>

        <div className="grid md:grid-cols-2 gap-12 mb-12" data-id="element-310">
          <div data-id="element-311">
            <div className="flex items-center gap-2 mb-6" data-id="element-312">
              <Zap className="w-6 h-6 text-electric fill-electric" data-id="element-313" />
              <span className="font-bold text-xl tracking-tight" data-id="element-314">
                BIBLIOTECAS DIGITALES™
              </span>
            </div>
            <p className="text-textsecondary max-w-md mb-6" data-id="element-315">
              El sistema N°1 para personas en Argentina que quieren generar
              ingresos en dólares trabajando desde casa.
              <br data-id="element-316" />
              <br data-id="element-317" />
              Porque ganar en USD no debería depender de tener experiencia
              previa, contactos o suerte. Debería depender de tener el sistema
              correcto.
            </p>
          </div>

          <div className="md:text-right flex flex-col md:items-end justify-center" data-id="element-318">
            <a href="mailto:soportebibliotecasdigitales@gmail.com" className="flex items-center gap-2 text-textsecondary hover:text-electric transition-colors mb-4" data-id="element-319">
              <Mail className="w-5 h-5" data-id="element-320" /> soportebibliotecasdigitales@gmail.com
            </a>
            <a href="#" className="flex items-center gap-2 text-textsecondary hover:text-electric transition-colors" data-id="element-321">
              <Globe className="w-5 h-5" data-id="element-322" /> www.bibliotecasdigitales.store
            </a>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row items-center justify-between gap-4 text-sm text-textsecondary/60" data-id="element-323">
          <p data-id="element-324">
            © Bibliotecas Digitales™ 2025 — Todos los derechos reservados.
          </p>
        </div>
      </div>
    </footer>;
}